import { type Common } from '../common.js';
import {
  type FlowRunBlockMetric,
  type FlowRunBlockMetricFindAllParams,
} from '../models/flow/flowRunBlockMetric.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/flow-run-block-metrics';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams?: FlowRunBlockMetricFindAllParams): Promise<FlowRunBlockMetric[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }
}
